import {
  Dialog as MUIDialog,
  DialogContent,
  Typography,
  DialogActions,
} from "@mui/material";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";

export default function ConfirmPopup({
  dialog,
  setDialog,
  reactivateCampaign,
  loading,
}) {
  const handleClose = () => {
    setDialog({ state: false });
  };

  return (
    <MUIDialog open={dialog.state} onClose={handleClose}>
      <DialogContent style={{ padding: "24px" }}>
        <Typography variant="subtitle1">
          Are you sure you want to reactivate this campaign?
        </Typography>
      </DialogContent>

      <DialogActions style={{ padding: "16px 24px" }}>
        <PrimaryLoadingButton
          loading={loading}
          onClick={reactivateCampaign}
          variant="contained"
        >
          Reactivate Campaign
        </PrimaryLoadingButton>
        <CancelButton variant="outlined" onClick={handleClose}>
          Cancel
        </CancelButton>
      </DialogActions>
    </MUIDialog>
  );
}
